import { render, staticRenderFns } from "./HMCheckBoxGroupStudent.vue?vue&type=template&id=a637a734&scoped=true&"
import script from "./HMCheckBoxGroupStudent.vue?vue&type=script&lang=ts&"
export * from "./HMCheckBoxGroupStudent.vue?vue&type=script&lang=ts&"
import style0 from "./HMCheckBoxGroupStudent.vue?vue&type=style&index=0&id=a637a734&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a637a734",
  null
  
)

export default component.exports